<template>
  <main id="app">
    <div class="app-container">
      <!-- TopHead is the header with the information about the app -->
      <TopHead v-if="app && messages.length > 0" :app="app"></TopHead>
      <section class="container chat-container">
        <!-- Welcome component is for onboarding experience and language picker -->
        <Welcome @submit="send" v-if="app && messages.length == 0" :app="app"></Welcome>

        <!-- Messages Table -->
        <section class="messages" v-else>
          <div v-for="m in messages" class="message">
            <div v-if="m.selfMessage" class="bubble-wrap">
              <!-- My message -->
              <Bubble :text="m.selfMessage" from="me" />
            </div>

            <div v-else class="bot-message">
              <div v-if="!m.selfImage" class="bot-pfp-container">
                <img alt="koin" class="bot-pfp" :src="app.kinUri" />
              </div>

              <div class="list">
                <!-- Component iterator (Dialogflow Gateway Feature) -->
                <div v-bind:class="['bot-bubble-wrap']" v-for="component in m.queryResult.fulfillmentMessages">
                  <!-- Default / Webhook bubble -->
                  <Bubble :text="component.content" v-if="component.name == 'DEFAULT'" />

                  <!-- Simple Response -->
                  <Bubble :text="component.content.displayText ||
                    component.content.textToSpeech
                    " v-if="component.name == 'SIMPLE_RESPONSE'" />

                  <!-- Card -->
                  <Card :title="component.content.title" :subtitle="component.content.subtitle"
                    :image="component.content.image" :text="component.content.formattedText"
                    :buttons="component.content.buttons" v-if="component.name == 'CARD'" />

                  <!-- Carousel layout and cards -->
                  <div class="carousel" v-if="component.name == 'CAROUSEL_CARD'">
                    <Card v-for="card in component.content" @click.native="send(card.info.key, 'card')"
                      :key="card.info.key" :title="card.title" :image="card.image" :subtitle="card.subtitle"
                      :text="card.description" />
                  </div>

                  <!-- List -->
                  <List @select="send" :items="component.content.items" :title="component.content.title"
                    v-if="component.name == 'LIST'" />

                  <!-- Webhook Image -->
                  <Picture v-if="component.name == 'IMAGE'" :image="component.content" />
                </div>
              </div>
            </div>
          </div>
          <div class="message" v-if="loading && !this.socket">
            <div class="bubble-wrap">
              <!-- Default / Webhook bubble (Loading) -->
              <Bubble loading="true" />
            </div>
          </div>
        </section>
      </section>

      <div style="display" :id="(this.srcUrl === '') ? 'NeoassistCentralDisabled' : 'NeoassistCentralEnabled'">
        <iframe id='NeoAssistIframe' :src="this.srcUrl" frameborder="0"></iframe>
      </div>

      <!-- ChatInput is made for submitting queres and displaying suggestions -->
      <ChatInput @submit="send" @submit_postback="send_postback" @sendImage="sendImage" :suggestions="suggestions"
        :checkCanSendImage="checkCanSendImage" :disabled="this.inputDisabled" v-if="!app || messages.length != 0">
      </ChatInput>

      <!-- Audio toggle (on the top right corner), used to toggle the audio output, default mode is defined in the settings -->
      <!-- <div
        :aria-label="
          (config.i18n[lang()] && config.i18n[lang()].muteTitle) ||
            config.i18n[config.app.fallback_lang].inputTitle
        "
        :title="
          (config.i18n[lang()] && config.i18n[lang()].muteTitle) ||
            config.i18n[config.app.fallback_lang].inputTitle
        "
        class="audio-toggle"
        @click="muted = !muted"
      >
        <i aria-hidden="true" class="material-icons" v-if="!muted">volume_up</i>
        <i aria-hidden="true" class="material-icons" v-else>volume_off</i>
      </div> -->
    </div>
  </main>
</template>

<style lang="sass">
@import url('https://selic.elife.com.br/external/fonts.googleapis.com/css/familyRoboto.css')

@media only screen and (min-width: 601px)
  .material-icons
    font-family: 'Material Icons'
    font-weight: normal
    font-style: normal
    font-size: 24px
    line-height: 1
    letter-spacing: normal
    text-transform: none
    display: inline-block
    white-space: nowrap
    word-wrap: normal
    direction: ltr
    -webkit-font-feature-settings: 'liga'
    -webkit-font-smoothing: antialiased
@media only screen and (max-width: 600px)
  .material-icons
    font-family: 'Material Icons'
    font-weight: normal
    font-style: normal
    font-size: 20px
    line-height: 1
    letter-spacing: normal
    text-transform: none
    display: inline-block
    white-space: nowrap
    word-wrap: normal
    direction: ltr
    -webkit-font-feature-settings: 'liga'
    -webkit-font-smoothing: antialiased
body
    margin: 0
    padding: 0
    font-family: Roboto, sans-serif
main
    height: 100vh
    box-sizing: border-box
.app-container
    background-color: white
    display: flex
    flex-direction: column
    height: 100%
    position: relative
    overflow: hidden
    // border-radius: 32px
    // box-shadow: 0 10px 15px -5px rgba(0, 0, 0, 0.4)
.chat-container
    width: 100%
    position: relative
    padding: 0 16px
    box-sizing: border-box
    flex: 1
    overflow-y: auto
    scroll-behavior: smooth
@font-face
    font-family: 'Material Icons'
    font-style: normal
    font-weight: 400
    font-display: swap
    src: url(https://selic.elife.com.br/external/fonts.gstatic.com/s/materialicons/v42/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2) format('woff2')
.fab
    top: calc(50% - 9px)
</style>

<style lang="sass" scoped>
@media only screen and (min-width: 601px)
  .carousel
    overflow-x: auto
    overflow-y: hidden
    -webkit-overflow-scrolling: touch
    box-sizing: border-box
    padding-bottom: 18px
    width: 100%
    display: flex
  .bot-bubble-wrap
    margin-bottom: 12px
    margin-left: 15px
    display: flex
    align-items: center
  .bot-pfp-container
    object-fit: cover
    padding: 10px
    margin-left: -15px
    margin-top: -10px
    .bot-pfp
      border-radius: 9px
      padding: 0px
      height: 58px
      width: 71px
      box-shadow: 0 2px 6px 2px rgba(60,64,67,0.15)
      object-fit: fill
  
  .message
    width: 100%
    box-sizing: border-box
    display: flex
    flex-direction: column
@media only screen and (max-width: 600px)
  .carousel
    overflow-x: auto
    overflow-y: hidden
    -webkit-overflow-scrolling: touch
    box-sizing: border-box
    width: 100%
    display: flex
  .bot-bubble-wrap
    display: flex
    align-items: center
    margin-bottom: 5px
  .bot-pfp-container
    object-fit: cover
    padding: 10px
    margin-left: -20px
    margin-top: -10px
    .bot-pfp
      border-radius: 9px
      padding: 0px
      height: 58px
      width: 71px
      box-shadow: 0 2px 6px 2px rgba(60,64,67,0.15)
      object-fit: fill
  
  .message
    width: 100%
    font-size: 12px
    box-sizing: border-box
    display: flex
    flex-direction: column
.list
  width: 100%
.bot-message
  display: flex
.bubble-wrap
  margin-top: 8px
  margin-bottom: 8px
.audio-toggle
  position: absolute
  top: 0
  right: 0
  margin: 16px
  z-index: 999
  padding: 10px
  background-color: #F1F3F4
  border-radius: 50%
  width: 24px
  height: 24px
  cursor: pointer
  color: #202124
.carousel .card
  max-width: 300px
#NeoassistCentralEnabled
  width: 100vw;
  height: 100vh;
#NeoassistCentralDisabled
  width: 0px
  height: 0px
#NeoAssistIframe
  width: 100%
  height: 100%
</style>

<script>
import Welcome from "./../Welcome/Welcome.vue";
import TopHead from "./../Partials/TopHead.vue";
import ChatInput from "./../Partials/ChatInput.vue";

import Bubble from "./../RichComponents/Bubble.vue";
import Card from "./../RichComponents/Card.vue";
import List from "./../RichComponents/List.vue";
import Picture from "./../RichComponents/Picture.vue";

import * as uuidv1 from "uuid/v1";

export default {
  name: "app",
  components: {
    Welcome,
    TopHead,
    ChatInput,
    Bubble,
    Card,
    List,
    Picture
  },
  data() {
    return {
      app: null,
      messages: [],
      socket: null,
      language: "",
      session: "",
      muted: this.config.app.muted,
      loading: false,
      srcUrl: "",
      inputDisabled: false,
      clearCache: false,
    };
  },
  mounted() {
    this.app = this.config.agent;
    if (this.history())
      localStorage.setItem("agent", JSON.stringify(this.config.agent));
    this.scrollDown();

    // Tenta reconectar ao websocket caso a conexão tenha sido
    // interrompida bruscamente
    if (localStorage.getItem("in_attendance") == "true") {
      this.connect(this.config.app.websocket);
    }
    // Evento recebido através do iframe
    window.addEventListener("message", this.scrollDown);
  },
  created() {
    /* If history is enabled, the messages are retrieved from localStorage */
    if (this.history() && localStorage.getItem("message_history") !== null) {
      this.messages = JSON.parse(localStorage.getItem("message_history"));
    }

    /* Session should be persistent (in case of page reload, the context should stay) */
    if (this.history() && localStorage.getItem("session") !== null) {
      this.session = localStorage.getItem("session");
    } else {
      this.session = uuidv1();
      if (this.history()) localStorage.setItem("session", this.session);
    }

    /* Cache Agent (this will save bandwith) */
    if (this.history() && localStorage.getItem("agent") !== null) {
      this.app = JSON.parse(localStorage.getItem("agent"));
    }
  },
  computed: {
    /* The code below is used to extract suggestions from last message, to display it on ChatInput */
    suggestions() {
      const lastMessageIsSelf =
        this.messages.length > 0 &&
        this.messages[this.messages.length - 1].selfMessage;
      if (this.socket) {
        return {
          text_suggestions: this.config.i18n[this.lang()].cancel
        };
      } else if (this.messages.length > 0 && !lastMessageIsSelf) {
        let last_message = this.messages[this.messages.length - 1].queryResult
          .fulfillmentMessages;
        let suggestions = {};

        for (let component in last_message) {
          if (last_message[component].name == "SUGGESTIONS")
            suggestions.text_suggestions = last_message[component].content;
          if (last_message[component].name == "POSTBACK_SUGGESTION")
            suggestions.postback_suggestion = last_message[component].content;
          if (last_message[component].name == "LINK_OUT_SUGGESTION")
            suggestions.link_suggestion = last_message[component].content;
        }

        return suggestions;
      } else {
        return {
          text_suggestions: this.config.app.start_suggestions // <- if no messages are present, return start_suggestions, from config.js to help user figure out what he can do with your application
        };
      }
    },
    checkCanSendImage() {
      const lastMessageIsSelf =
        this.messages.length > 0 &&
        this.messages[this.messages.length - 1].selfMessage;

      if (this.messages.length > 0 && !lastMessageIsSelf) {
        let last_message = this.messages[this.messages.length - 1].queryResult
          .fulfillmentMessages;

        for (let component in last_message) {
          if (last_message[component].name === "SEND_IMAGE") {
            return last_message[component].content;
          }
        }
      }
      return {};
    }
  },
  watch: {
    /* This function is triggered, when new messages arrive */
    messages(messages) {
      if (this.history())
        localStorage.setItem("message_history", JSON.stringify(messages)); // <- Save history if the feature is enabled
    },
    /* This function is triggered, when request is started or finished */
    loading() {
      this.scrollDown();
    }
  },
  methods: {
    log(m) {
      console.log(m);
    },
    addMessage(msg, isFromMe = false) {
      let data;
      if (isFromMe) {
        data = {
          selfMessage: msg
        };
      } else {
        data = {
          queryResult: {
            fulfillmentMessages: [
              {
                name: "DEFAULT",
                content: msg
              }
            ]
          }
        };
        this.handle(data);
      }
      this.messages.push(data);
      this.scrollDown();
    },
    addImageMessage(url, accessibilityText) {
      let data = {
        queryResult: {
          fulfillmentMessages: [
            {
              name: "IMAGE",
              content: {
                imageUri: url,
                accessibilityText,
                from: "me"
              }
            }
          ]
        }
      };
      // this.handle(data);
      this.messages.push(data);
      this.scrollDown();
    },
    scrollDown() {
      requestAnimationFrame(() => {
        let container = document.querySelector("#app .container");
        container.scrollTop = container.scrollHeight;
      });
    },
    connect(socketUrl) {
      this.socket = new WebSocket(
        socketUrl.replace(":session_id", this.session),
        "echo-protocol"
      );
      this.socket.onopen = data => {
        localStorage.setItem("in_attendance", "true");
        this.inputDisabled = true;
      };
      this.socket.onerror = e => {
        console.log("O Erro:", e)
        this.addMessage("Não foi possível conectar no momento.");
      };
      this.socket.onmessage = e => {
        console.log("ok");
        const data = e.data;
        const dataObject = JSON.parse(data);
        this.loading = false;
        if (dataObject) {
          if (dataObject.message && dataObject.message.text && dataObject.message.text === 'close_websocket') {
            this.srcUrl = ''
            this.inputDisabled = false;
            this.close();
          }
          else {
            if (dataObject.message && dataObject.message.text && !dataObject.message.text.startsWith("Seu protocolo de atendimento é")) {
              this.srcUrl = ''
              this.addMessage(dataObject.message.text);
              this.scrollDown();
            }
            if (dataObject.unread) {
              dataObject.unread.forEach(msg => {
                if (msg.text) this.addMessage(msg.text);
              });
              this.scrollDown();
            }
            if (dataObject.isComplexMessages) {
              this.handle(dataObject.dialogflow);
              this.scrollDown();
            }
          }
        }
      };
      this.socket.onclose = e => {
        localStorage.setItem("in_attendance", "false");
        this.socket = null;
        document.body.onunload = null;
        if (e.code === 1002) {
          this.send("Reativar assistente virtual");
        }
      };
    },
    close() {
      console.log("SOCKET ANTES", this.socket)
      if (this.socket) this.socket.close();
      console.log("SOCKET DEPOIS", this.socket)

      fetch(this.config.app.cancel, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: this.session, origin: "user" })
      });
    },
    validate(data) {
      if (data) {
        if (data.queryResult) {
          if (Array.isArray(data.queryResult.fulfillmentMessages)) {
            return true;
          }
        }
      }
      return false;
    },
    send(q, template = 'default') {
      this.addMessage(q, true);

      let request = {
        session_id: this.session,
        text: q,
        template,
        origin: {
          type: "USER"
        }
      }; // <- this is how a Dialogflow request looks like

      // Envia mensagem pelo socket, caso exista uma conexão ativa
      if (this.socket) {
        this.socket.send(q);
      }

      // Todas as mensagens são enviadas para o dialogflow,
      // mesmo quando em atendimento
      // para garantir que o app conseguirá receber comandos

      this.loading = true;
      fetch(this.config.app.gateway, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(request)
      })
        .then(response => {
          return response.json();
        })
        .then(res => {
          let response = res.data.response;
          this.handle(response);
        })
        .catch(e => {
          console.log("error", e);
        });
    },
    send_postback(q, postback, template = 'default') {
      this.addMessage(q, true);
      let request = {
        session_id: this.session,
        text: postback,
        template,
        origin: {
          type: "USER"
        }
      }; // <- this is how a Dialogflow request looks like
      // Envia mensagem pelo socket, caso exista uma conexão ativa
      if (this.socket) {
        this.socket.send(postback);
      }
      // Todas as mensagens são enviadas para o dialogflow,
      // mesmo quando em atendimento
      // para garantir que o app conseguirá receber comandos
      this.loading = true;
      fetch(this.config.app.gateway, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(request)
      })
        .then(response => {
          return response.json();
        })
        .then(res => {
          let response = res.data.response;
          this.handle(response);
        })
        .catch(e => {
          console.log("error", e);
        });
    },
    handle(response) {
      let shouldDisplayDFMessage = false;

      //dynamic input
      const parameters = response.queryResult.parameters?.fields;
      const disableInput = parameters?.inputDisabled;
      const srcUrl = parameters?.chatUrl;
      this.inputDisabled = !!disableInput;
      this.srcUrl = srcUrl ? srcUrl.stringValue : '';


      for (let component in response.queryResult.fulfillmentMessages) {
        const messageData = response.queryResult.fulfillmentMessages[component];

        // Support components trigger chat support

        if (messageData.name === "SUPPORT") {
          // shouldDisplayDFMessage = true;
          if (messageData.action === "START") {
            this.connect(this.config.app.websocket);
          } else {
            this.close();
            this.socket = undefined
          }
        }

        let text; // <- init a text variable

        /* Set the text variable according to component name */
        if (messageData.name == "DEFAULT") text = messageData.content;
        if (messageData.name == "SIMPLE_RESPONSE")
          text = messageData.content.textToSpeech;

        if (window.SpeechSynthesisUtterance) {
          let speech = new SpeechSynthesisUtterance(text);
          speech.voiceURI = "native"; // <- change this, to get a different voice

          /* This "hack" is used to format our lang format, to some other lang format (example: en -> en_EN). Mainly for Safari, Firefox and Edge */
          speech.lang = this.lang() + "-" + this.lang().toUpperCase();

          if (!this.muted) window.speechSynthesis.speak(speech); // <- if app is not muted, speak out the speech
        }
      }

      if (!this.socket || shouldDisplayDFMessage) {

        this.messages.push(response);
        this.loading = false;
      }
    },
    sendImage(attachment, payload) {
      var formData = new FormData();
      formData.append("file", attachment);

      this.loading = true;
      fetch(`${this.config.app.base}/files/upload/image?session_id=${this.session}&last_message=${this.getLastBotMessage()}`, {
        method: "POST",
        body: formData
      })
        .then(async response => {
          const { file_id } = await response.json();
          this.addImageMessage(`${this.config.app.base}/files/image/${file_id}`, file_id);
          this.send(payload);
        })
        .catch(e => {
          console.log("error", e);
        });
    },
    getLastBotMessage() {
      let lastBotMessage = '';

      if (this.messages.length > 0) {
        let last_message = this.messages[this.messages.length - 1].queryResult.fulfillmentMessages;

        for (let component in last_message) {
          if (last_message[component].name === "DEFAULT") {
            if (lastBotMessage === '') {
              lastBotMessage = last_message[component].content;
            } else {
              lastBotMessage += `%0D%0A${last_message[component].content}`;
            }
          }
        }
      }
      return lastBotMessage;
    }
  }
};
</script>
